import { EventBus } from "../events/EventBus";
import { FlowDefinition } from "./FlowDefinition";
import { StepFlow } from "./StepFlow";
import { FlowRunner } from "./FlowRunner";

// =============================================================================
// NestedFlowStep: Wraps a FlowDefinition as a step within another flow.
// When executed, it creates a nested FlowRunner to run the encapsulated flow.
// =============================================================================

export class NestedFlowStep extends StepFlow {
  verbose: boolean = false;
  private runner!: FlowRunner;
  get stepType() { return "NestedStep"; }
  public nestedFlow: FlowDefinition; // Holds the nested flow definition

  constructor(eventBus: EventBus, nestedFlow: FlowDefinition) {
    super(eventBus);
    this.nestedFlow = nestedFlow;
  }

  // Returns the name of the nested flow as the step name
  get stepName(): string {
    return this.nestedFlow.name;
  }

  // Executes the nested flow using a new FlowRunner instance
  async onExecute(): Promise<void> {    
    this.runner = new FlowRunner(this.nestedFlow as any, this.eventBus);
    this.runner.setContext(this._context);
    this.runner.verbose = this.verbose;
    await this.runner.execute(); // Runs the nested flow
    this.next(); // Signal completion of this step
  }
  async onCancel(): Promise<void> {    
    this.runner?.cancel();
  }
}